import {ENDPOINT_PANEL_V2_SESSIONS, ENDPOINT_PANEL_V2_SESSION, ENDPOINT_PANEL_V2} from 'common/endpoints';
import _ from 'lodash';
import {commonJwtHeader, commonJwtHeaderNoCT} from 'common/utils';
import goStore from 'go/store';

const getRequestOptions = (token) => ({
  method: 'GET',
  headers: commonJwtHeader(),
}); 

const getPanelSessionInfo = (token, sessionId) =>
  fetch(`${ENDPOINT_PANEL_V2_SESSION}${sessionId}`, {
    method: 'GET',
    headers: commonJwtHeader(),
  });

const getPanelSessionConfiguration = (token, sessionId, taskDefKey) =>
  fetch(`${ENDPOINT_PANEL_V2_SESSION}${sessionId}/config/${taskDefKey}`, {
    method: 'GET',
    headers: commonJwtHeader(),
  });

const getReviewersBySession = (token, sessionId, pageNum) => {
  const offset = pageNum * 20;
  return fetch(
    `${ENDPOINT_PANEL_V2_SESSION}${sessionId}/reviewers?limit=20&offset=${offset}&sortBy=firstName&sortDir=ASC`,
    {
      method: 'GET',
      headers: commonJwtHeader(),
    }
  );
};

const setBulkStatus = (emailIds, sessionId, status) => {
  return fetch(
    `${ENDPOINT_PANEL_V2_SESSION}${sessionId}/reviewers/status`,
    {
      method: 'PUT',
      headers: commonJwtHeader(),
      body: JSON.stringify({
        userIds: emailIds,
        status: status,
      }),
    }
  );
};

const setBulkGroup = (emailIds, sessionId, group) => {
  return fetch(
    `${ENDPOINT_PANEL_V2_SESSION}${sessionId}/reviewers/group`,
    {
      method: 'PUT',
      headers: commonJwtHeader(),
      body: JSON.stringify({
        userIds: emailIds,
        groupName: group,
      }),
    }
  );
};
const fetchAllCategories = (sessionId) => {
  return fetch(
    `${ENDPOINT_PANEL_V2_SESSION}${sessionId}/categories`, {
      method: 'GET',
      headers: commonJwtHeader()
    }
  );
}


const updateGroup = ({ sessionId, groupId, categories, suspended }) => { 
  return fetch( `${ENDPOINT_PANEL_V2_SESSION}${sessionId}/groups/${groupId}/categories`,
  {
    method: 'POST',
    headers: commonJwtHeader(),
    body: JSON.stringify(
      categories
    )
  })
}

const addGroup = (token, sessionId, groupBody) =>
  fetch(`${ENDPOINT_PANEL_V2_SESSION}${sessionId}/groupsv3`, {
    method: 'POST',
    headers: commonJwtHeader(),
    body: JSON.stringify(groupBody),
  });

const getReviewersBySessionAndGroup = (token, sessionId, groupId) =>
  fetch(`${ENDPOINT_PANEL_V2_SESSION}${sessionId}/groups/${groupId}/reviewers`, {
    method: 'GET',
    headers: commonJwtHeader(),
  });

const getReviewerBySessionAndId = (token, sessionId, userId) =>
  fetch(`${ENDPOINT_PANEL_V2_SESSION}${sessionId}/reviewers/${userId}`, {
    method: 'GET',
    headers: commonJwtHeader(),
  });

const getEntitiesBySession = (token, sessionId, pageNum) => {
  const offset = pageNum * 20;
  return fetch(
    `${ENDPOINT_PANEL_V2_SESSION}${sessionId}/entities?limit=20&offset=${offset}&sortBy=SessionEntityId&sortDir=ASC`,
    {
      method: 'GET',
      headers: commonJwtHeader(),
    }
  );
};

const getSessionEntity = (token, sessionId, entityId) =>
  fetch(
    `${ENDPOINT_PANEL_V2_SESSION}${sessionId}/entities/${entityId}`,
    getRequestOptions(token)
  );

const reviewersSearch = (token, sessionId, pageNum, body) => { 
 return fetch(`${ENDPOINT_PANEL_V2_SESSION}${sessionId}/reviewers/search?pageNum=${pageNum}`, {
    method: 'POST',
    headers: commonJwtHeader(),
    body: JSON.stringify(body),
  });
}

const conflictOfInterest = (token, sessionId, entityId) =>
  fetch(`${ENDPOINT_PANEL_V2_SESSION}${sessionId}/entities/${entityId}/conflict`, {
    method: 'POST',
    headers: commonJwtHeader(),
  });

const getSessionsByProgramId = (token, programIds) => {
  let endpoint;
  _.forEach(programIds, (id) => {
    if (id !== programIds[0]) {
      endpoint = endpoint + `&programId=${id}`;
    } else {
      endpoint = `${ENDPOINT_PANEL_V2_SESSIONS}?programId=${id}`;
    }
  });
  return fetch(`${endpoint}`, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};

const getGroupsBySession = (token, sessionId, pageNum, pageSize) => {
  let endPoint = `${ENDPOINT_PANEL_V2_SESSION}${sessionId}/groups`;
  if (pageNum !== undefined) {
    const offset = pageNum * pageSize;
    endPoint = `${ENDPOINT_PANEL_V2_SESSION}${sessionId}/groups?limit=${pageSize}&offset=${offset}&sortBy=name&sortDir=DESC`;
  }
  return fetch(`${endPoint}`, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};

const getGroupBySessionAndGroupId = (token, sessionId, groupId) => {
  let endPoint = `${ENDPOINT_PANEL_V2_SESSION}${sessionId}/groups/${groupId}`;
  return fetch(`${endPoint}`, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};

const getGroupNamesBySession = (token, sessionId) => {
  let endPoint = `${ENDPOINT_PANEL_V2_SESSION}${sessionId}/groupNames`;
  return fetch(`${endPoint}`, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};

const updateReviewer = (token, userId, sessionId, newReviewerObj) =>
  //FIXME: hardcoded group Id
  fetch(
    `${ENDPOINT_PANEL_V2_SESSION}${sessionId}/reviewers/${encodeURIComponent(userId)}`,
    {
      method: 'PUT',
      headers: commonJwtHeader(),
      body: JSON.stringify({
        userId: userId,
        sessionId: +sessionId,
        groupId: newReviewerObj.groups[0].groupId,
        firstName: newReviewerObj.firstName,
        lastName: newReviewerObj.lastName,
        suspended: newReviewerObj.suspended,
      }),
    }
  );

const updateEntity = (token, entityId, sessionId, newEntity) => {
  return fetch(`${ENDPOINT_PANEL_V2_SESSION}${sessionId}/entities/${entityId}`, {
    method: 'PUT',
    headers: commonJwtHeader(),
    body: JSON.stringify({
      sessionId: +sessionId,
      entityId: entityId,
      entityType: newEntity.entityType,
      groupId: newEntity.groupId,
      grantId: newEntity.grantId,
      category: newEntity.category,
      rank: newEntity.rank,
      totalRank: newEntity.totalRank,
      overallScore: newEntity.overallScore,
      status: newEntity.status,
      organizationName: newEntity.organizationName,
      entityDisplay: newEntity.entityDisplay,
      subGrantId: newEntity.subGrantId,
    }),
  });
};

const addReviewerToGroup = (token, userId, sessionId, groupId) =>
  fetch(
    `${ENDPOINT_PANEL_V2_SESSION}${sessionId}/groups/${groupId}/reviewers/${encodeURIComponent(
      userId
    )}`,
    {
      method: 'PUT',
      headers: commonJwtHeader(),
    }
  );

const removeReviewerFromGroup = (token, userId, sessionId, groupId) =>
  fetch(
    `${ENDPOINT_PANEL_V2_SESSION}${sessionId}/groups/${groupId}/reviewers/${encodeURIComponent(
      userId
    )}`,
    {
      method: 'DELETE',
      headers: commonJwtHeader(),
    }
  );

const updateSuspendedDataForReviewer = (token, userId, sessionId, suspendedObj) =>
  fetch(
    `${ENDPOINT_PANEL_V2_SESSION}${sessionId}/reviewers/${encodeURIComponent(
      userId
    )}/suspended`,
    {
      method: 'PUT',
      headers: commonJwtHeader(),
      body: JSON.stringify({
        suspended: suspendedObj.suspended,
      }),
    }
  );

const reassignReviewer = (token, sessionId, entityId, oldReviewerId, newReviewerId) =>
  fetch(`${ENDPOINT_PANEL_V2_SESSION}${sessionId}/entities/${entityId}/reviewers`, {
    method: 'PUT',
    headers: commonJwtHeader(),
    body: JSON.stringify({
      newUserId: newReviewerId,
      oldUserId: oldReviewerId,
    }),
  });

const administrativeClose = (token, sessionId, entityId) =>
  fetch(
    `${ENDPOINT_PANEL_V2_SESSION}${sessionId}/entities/${entityId}/status/administrativeClose`,
    {
      method: 'PUT',
      headers: commonJwtHeader(),
    }
  );

const addReviewer = (token, sessionId, reviewerBody) =>
  fetch(`${ENDPOINT_PANEL_V2_SESSION}${sessionId}/reviewers`, {
    method: 'POST',
    headers: commonJwtHeader(),
    body: JSON.stringify(reviewerBody),
  });

const uploadFileData = (token, sessionId, formData) => 
fetch(`${ENDPOINT_PANEL_V2_SESSION}${sessionId}/bulkReviewers/spreadSheet`, {
  method: 'POST',
  headers: commonJwtHeaderNoCT(),
  body: formData,
});

const addChair = (token, sessionId, chairBody) =>
  fetch(`${ENDPOINT_PANEL_V2_SESSION}${sessionId}/chairs`, {
    method: 'POST',
    headers: commonJwtHeader(),
    body: JSON.stringify(chairBody),
  });

const uploadFileDataChairs = (token, sessionId, formData) => 
fetch(`${ENDPOINT_PANEL_V2_SESSION}${sessionId}/bulkChairs/spreadSheet`, {
  method: 'POST',
  headers: commonJwtHeaderNoCT(),
  body: formData,
});

const updateSuspendedDataForChair = (emailIds, sessionId, status) => {
  return fetch(
    `${ENDPOINT_PANEL_V2_SESSION}${sessionId}/chairs/suspended`,
    {
      method: 'PUT',
      headers: commonJwtHeader(),
      body: JSON.stringify({
        userIds: emailIds,
        status: status,
      }),
    }
  );
} 

const getChairBySessionAndId = (token, sessionId, userId) =>
  fetch(`${ENDPOINT_PANEL_V2_SESSION}${sessionId}/chairs/${userId}`, {
    method: 'GET',
    headers: commonJwtHeader(),
 });

const getChairsBySession = (token, sessionId, pageNum) => {
    const offset = pageNum * 20;
    return fetch(
      `${ENDPOINT_PANEL_V2_SESSION}${sessionId}/chairs?limit=20&offset=${offset}&sortBy=firstName&sortDir=ASC`,
      {
        method: 'GET',
        headers: commonJwtHeader(),
      }
    );
  };

const updateSuspendedDataForGroup = (token, groupId, sessionId, suspendedObj) =>
  fetch(`${ENDPOINT_PANEL_V2_SESSION}${sessionId}/groups/${groupId}/suspended`, {
    method: 'PUT',
    headers: commonJwtHeader(),
    body: JSON.stringify({
      suspended: suspendedObj.suspended,
    }),
  });

  const getPanelsAttachment = () => {
    const state = goStore.store.getState();
    const csrftoken = _.get(state, 'auth.token._csrftoken');
    return `${ENDPOINT_PANEL_V2}template?_csrftoken=${csrftoken}`;
  };

export default {
  getSessionEntity,
  getPanelSessionInfo,
  getPanelSessionConfiguration,
  conflictOfInterest,
  getReviewersBySession,
  getReviewersBySessionAndGroup,
  setBulkStatus,
  setBulkGroup,
  getEntitiesBySession,
  getSessionsByProgramId,
  getReviewerBySessionAndId,
  updateReviewer,
  updateEntity,
  getGroupsBySession,
  getGroupBySessionAndGroupId,
  getGroupNamesBySession,
  getPanelsAttachment,
  addReviewerToGroup,
  removeReviewerFromGroup,
  updateSuspendedDataForReviewer,
  reassignReviewer,
  administrativeClose,
  addReviewer,
  updateSuspendedDataForGroup,
  reviewersSearch,
  fetchAllCategories,
  updateGroup,
  addGroup,
  uploadFileData,
  uploadFileDataChairs,
  addChair,
  updateSuspendedDataForChair,
  getChairBySessionAndId,
  getChairsBySession
};
